import { Component } from '@angular/core';

@Component({
  selector: 'not-found',
  template: require('./not-found.component.html'),
  styles: [require('./not-found.component.scss')],
})
export class NotFoundComponent {}
